import { NbDialogService, NbToastrService, NbDialogRef } from '@nebular/theme';
import { PagingService } from '../../../../shared/Services/PagingService';
import { FormMAsterService } from '../../services/formMaster.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { CreateFormComponent } from '../create/create.component';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  // tslint:disable-next-line: component-selector
  selector: 'formsmaster-get-fields',
  templateUrl: './get.component.html',
  styleUrls: ['./get.component.scss'],
})
export class GetFormMasterFieldsPopupComponent extends BaseComponent implements OnInit {
  fields: any;
  @Input() formId: number;
  @Input() refId: number;
  @Input() refType: string;
  @Output() Saved = new EventEmitter();
  linearMode = true;
  constructor(
    public route: Router,
    public service: FormMAsterService,
    public paging: PagingService,
    private diag: NbDialogService,
    private toast: NbToastrService,
    private aRoute: ActivatedRoute,
    private diagRef: NbDialogRef<GetFormMasterFieldsPopupComponent>,
    public sanitizer: DomSanitizer,
  ) {
    super(route, service, paging);
  }

  ngOnInit() {
    this.diagRef.onClose.subscribe((res) => {
      this.diagRef.close('false');
    });
    this.service.getById(this.formId).subscribe((res) => {
      this.fields = res;
      this.finishLoading = true;
    });
    //   this.loadEntities();
  }

  formsfields(id) {
    this.route.navigate(['admin/dynamicForms/formsfields/' + id]);
  }

  addForm() {
    this.diag.open(CreateFormComponent).onClose.subscribe((res) => {
      if (res === 'true') this.ngOnInit();
    });
  }

  active(id) {
    this.service.post({ id: id }, '/Apply').subscribe(
      (res) => {
        this.toast.success('Active form successfully', 'sucess', { duration: 4000 });
      },
      (err) => {
        this.toast.danger('Failed To active form', 'Failed', { duration: 4000 });
      }
    );
  }

  save() {
    if (
      this.fields.formsFieldsSections == null ||
      (this.fields.formsFieldsSections != null && this.fields.formsFieldsSections.length == 0) ||
      this.fields.formsFieldsSections.length === 1
    ) {
    } else {
      this.fields.type = 1;
    }

    this.fields.formsFields.forEach((element) => {
      element.dataRef = this.refId;
      element.dataRefType = this.refType;
    });
    this.service.post(this.fields, '/SaveForm').subscribe(
      (res) => {
        this.toast.success('Submit Data Successfully', 'sucess', { duration: 4000 });
        console.log(res);

        this.Saved.emit({event : res});
     //   this.diagRef.close(res);
        // this.diagRef.close();
      },
      (er) => {
        this.diagRef.close('false');
      }
    );

    // this.service.post(this.fields, '/GetForm').subscribe((res) => {
    //   this.toast.success('Submit Data Successfully', 'sucess', { duration: 4000 });
    //   this.diagRef.close();
    // });
  }
  uploadFile(files: any, item) {
    const formData = new FormData();
    for (let file of files) {
      formData.append(file.name, file);
    }
    this.service.uploadFile(formData).subscribe((res) => {
      item.submittedValue = res.fileName;
    });
  }

  getLabelData(text) {
    console.log(text);

    return this.sanitizer.bypassSecurityTrustHtml(text);
  }
}
